module.exports = __webpack_public_path__ + "static/media/cafe24-step2.db88a2a0.png";